// libs
import React, { memo } from 'react';

// styles
import { GradientTextContainer } from './styles';

interface IGradientTextProps {
  text?: string;
  children?: React.ReactNode;
  gradientColors: string[];
  degree?: number;
  className?: string;
  style?: React.CSSProperties;
}

const GradientText = ({
  text,
  children,
  gradientColors,
  degree = 90,
  className,
  style,
}: IGradientTextProps) => {
  return (
    <GradientTextContainer
      bgGradient={gradientColors}
      degree={degree}
      className={className}
      style={style}
    >
      {children || text}
    </GradientTextContainer>
  );
};

export default memo(GradientText);
